import { useCallback, useEffect, useState } from 'react';
import { getMyChannels } from 'api/channel';
import { MyChannelsData } from 'types/channel';

const useGetMyChannels = ():[MyChannelsData, null | boolean, string, ()=>void] => {
    const [data, setData] = useState({
        freeList: [],
        premiumList: [],
        remainChannelList: [],
        standardList: [],
    });
    const [loading, setLoading] = useState<null | boolean>(null);
    const [error, setError] = useState('');

    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getMyChannels();

            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res.error);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, error, fetch];
};

export default useGetMyChannels;
